import React from 'react';
import contractsModule from './contracts';

const contracts = contractsModule.default || contractsModule;
const { SOURCE } = contracts;

/**
 * SourceBadge - Renders the provenance as a clean, elegant meta caption.
 * Per D-15 and user feedback, eliminates cluttered colored pills in favor of
 * refined, understated enterprise typography with subtle indicator dots.
 */
export default function SourceBadge({ source }) {
  if (!source) {
    return (
      <span className="ai-crew-provenance-caption">
        <span className="ai-crew-provenance-dot unset" />
        not set
      </span>
    );
  }

  const { type, basis } = source;

  switch (type) {
    case SOURCE?.PROMPT || 'PROMPT':
      return (
        <span className="ai-crew-provenance-caption">
          <span className="ai-crew-provenance-dot prompt" />
          from your request
        </span>
      );

    case SOURCE?.TEMPLATE || 'TEMPLATE': {
      const text = basis ? `template ${basis}` : 'from template';
      return (
        <span className="ai-crew-provenance-caption">
          <span className="ai-crew-provenance-dot template" />
          {text}
        </span>
      );
    }

    case SOURCE?.PRECEDENT || 'PRECEDENT': {
      const text = basis || 'from past crews';
      return (
        <span className="ai-crew-provenance-caption">
          <span className="ai-crew-provenance-dot precedent" />
          {text}
        </span>
      );
    }

    case SOURCE?.PROFILE || 'PROFILE':
      return (
        <span className="ai-crew-provenance-caption">
          <span className="ai-crew-provenance-dot profile" />
          from your profile
        </span>
      );

    case SOURCE?.NONE || 'NONE':
    default:
      return (
        <span className="ai-crew-provenance-caption">
          <span className="ai-crew-provenance-dot unset" />
          not set
        </span>
      );
  }
}
